// extracted by mini-css-extract-plugin
export var fullScreenModal = "ImageCarousel-module--full-screen-modal---wTyA";
export var gallery = "ImageCarousel-module--gallery--25ztP";
export var shrinked = "ImageCarousel-module--shrinked--1-YGj";
export var carouselImage = "ImageCarousel-module--carousel-image--pvO1g";
export var imageContainer = "ImageCarousel-module--image-container--2PY6w";
export var closeModalButton = "ImageCarousel-module--close-modal-button--36c3x";
export var blackBackgroundModal = "ImageCarousel-module--black-background-modal--ZINaS";
export var fullScreenCarouselImage = "ImageCarousel-module--full-screen-carousel-image--1LbKF";
export var fullScreenImageContainer = "ImageCarousel-module--full-screen-image-container--3dRak";